module.exports = __webpack_public_path__ + "static/media/fvs_valve1_81.ff5db86f.jpg";